import styled from 'styled-components'

export const ErrorMessage = styled.span`
    color: red;
`
